import React, { useEffect, useState } from "react";
import { Form, Button } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import slide1Img from "../../assets/images/Phone_Greetings_image.png";
import slide2Img from "../../assets/images/Morning_skincare.png";
import slide3Img from "../../assets/images/Night_skincare.png";
import bannerMobileImg from "../../assets/images/banner-mobile.png";
import { ArrowRightOutlined } from "@ant-design/icons";
import ReCaptcha from "../reCaptcha/reCaptcha";
import headerImg from "../../assets/images/SneakPeakRoutine.png";

interface Props {
  activeQustionNumber?: any;
  setActiveQuestionNumber?: any;
}

// const SITE_KEY = "6LcCvzwrAAAAAL7mrXErZSO_-_I8KruvVh7ABNV-";
const SITE_KEY = "64943394-c608-4298-ba5a-cb0e70a23eb0";

const StartQuiz: React.FC<Props> = ({
  activeQustionNumber,
  setActiveQuestionNumber,
}) => {
  const [swiper, setSwiper] = useState<any>(null);

  const handleNext = () => {
    setActiveQuestionNumber(activeQustionNumber + 1);
  };

  return (
    <div className="answer-input-wrapper">
      {/* <div style={{ marginInline: "auto" }}>
        <img
          src={headerImg}
          alt="Sneak Peak Routine"
          style={{ width: "100%", maxWidth: "130px" }}
        />
      </div> */}
      <Swiper
        slidesPerView={1}
        onSwiper={(swiper: any) => setSwiper(swiper)}
        onSlideChange={(val: any) => {}}
        navigation={true}
        loop={true}
        modules={[Navigation, Thumbs]}
        className="form-swiper"
      >
        <SwiperSlide>
          <img
            src={bannerMobileImg}
            alt="Skin Quiz 1"
            style={{ width: "100%", maxWidth: "260px" }}
          />
        </SwiperSlide>
        {/* <SwiperSlide>
          <img
            src={slide2Img}
            alt="Skin Quiz 2"
            style={{ width: "100%", maxWidth: "260px" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slide3Img}
            alt="Skin Quiz 3"
            style={{ width: "100%", maxWidth: "260px" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slide1Img}
            alt="Skin Quiz 1"
            style={{ width: "100%", maxWidth: "260px" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slide2Img}
            alt="Skin Quiz 2"
            style={{ width: "100%", maxWidth: "260px" }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slide3Img}
            alt="Skin Quiz 3"
            style={{ width: "100%", maxWidth: "260px" }}
          />
        </SwiperSlide> */}
      </Swiper>
      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "1rem",
        }}
      >
        {/* <ReCAPTCHA
          sitekey={
            process.env.REACT_RECAPTCHA_KEY ||
            "6LfstjkrAAAAAKXf91DWc6SpsFbr-uG8lbOylQwp"
          }
          onChange={onRecaptchaChange}
        /> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReCaptcha sitekey={SITE_KEY} next={handleNext} />
          <span
            style={{
              fontSize: "12px",
              textAlign: "center",
              fontStyle: "italic",
            }}
          >
            Verify! Only humans are allowed - No bots.
          </span>
          {/* <Button
            className="btn-primary proceed-btn"
            onClick={() => {
              setActiveQuestionNumber(activeQustionNumber + 1);
            }}
          >
            Next
            <ArrowRightOutlined />
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default StartQuiz;
